
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { EstimateFormValues } from '../types/estimateFormTypes';
import { CustomerOption } from '../hooks/useCustomers';
import SearchableCustomerSelect from '@/components/shared/SearchableCustomerSelect';

interface EstimateBasicFieldsProps {
  form: UseFormReturn<EstimateFormValues>;
  customers?: CustomerOption[];
}

const EstimateBasicFields: React.FC<EstimateBasicFieldsProps> = ({ form, customers }) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Estimate Title</FormLabel>
              <FormControl>
                <Input placeholder="e.g. Kitchen Renovation" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="customer_id"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Customer</FormLabel>
              <FormControl>
                <SearchableCustomerSelect
                  value={field.value || ''}
                  onValueChange={field.onChange}
                  customers={customers}
                  allowNone
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Add any additional details about this estimate"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default EstimateBasicFields;
